export default __webpack_public_path__ + "static/media/comment.inline.f0cd170c.svg";